var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isClosed)?_c('div',[(_vm.currentStep === 1)?_c('FirstStep'):_vm._e(),(_vm.currentStep === 2)?_c('SubmitStep'):_vm._e(),(_vm.currentStep === 4)?_c('SuccessStep',{attrs:{"iconChecked":_vm.iconChecked}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }